import { forwardRef } from 'react';

import { Box } from '@mui/material';

import { useSession } from '@/providers/SessionProvider/SessionProvider';

import PrimaryNavClientCard from './PrimaryNavClientCard/PrimaryNavClientCard';
import PrimaryNavClientCardSkeleton from './PrimaryNavClientCardSkeleton/PrimaryNavClientCardSkeleton';

const PrimaryNavClientCardWrapper = forwardRef<HTMLDivElement>((_, ref) => {
  const { isCurrentClientLoading } = useSession();

  return (
    <Box ref={ref}>
      {isCurrentClientLoading ? (
        <PrimaryNavClientCardSkeleton />
      ) : (
        <PrimaryNavClientCard />
      )}
    </Box>
  );
});

export default PrimaryNavClientCardWrapper;
